export default "__VITE_ASSET__BojOy5K8__"